let isUpdating = false;

async function updateQuantityLimits() {
  try {
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    const quantitySelector = document.querySelector('.product__ctas hh-quantity-input');
    const productForm = document.querySelector('.product__ctas hh-product-form');

    if (!quantitySelector || !productForm) return;

    const currentVariantId = parseInt(productForm.dataset.itemid);
    const maxQtyFromMetafield = parseInt(productForm.dataset.maxqty);

    if (!maxQtyFromMetafield) return; // No limit set

    // Calculate items already in cart for this variant
    const itemsInCart = cartData.items
      .filter(item => item.variant_id === currentVariantId)
      .reduce((total, item) => total + item.quantity, 0);

    // Calculate and update new max quantity
    const newMaxQty = Math.max(1, maxQtyFromMetafield - itemsInCart);
    quantitySelector.max = newMaxQty;

  } catch (error) {
    console.error('Error updating quantity limits:', error);
  }
}

async function updateCartNotificationPrices(inputQuantity, quantityAdded) {
  if (!inputQuantity || !quantityAdded || quantityAdded <= 1) return;

  const cartNotification = document.querySelector(
    `#cart-notification-product-${inputQuantity.dataset.product}-${inputQuantity.dataset.sellingplan}`
  );

  if (!cartNotification) return;

  const pricePlace = cartNotification.querySelector('.cart-notification__product .price dd');
  const subscriptionPricePlace = cartNotification.querySelector('.cart-notification__product .price dd.price__subscription');

  // Update regular price
  if (pricePlace) {
    pricePlace.innerHTML = `$${window.variantPrice * quantityAdded}`;
  }

  // Update subscription price
  if (subscriptionPricePlace) {
    const subscriptionPriceAmount = parseFloat(
      subscriptionPricePlace.textContent.trim().replace(/[^0-9.]/g, '')
    );
    if (subscriptionPriceAmount) {
      subscriptionPricePlace.innerHTML = `$${(subscriptionPriceAmount * quantityAdded).toFixed(2)}`;
    }
  }
}

window.addEventListener('custom::cart-updated', async () => {
  // Prevent recursion
  if (isUpdating) return;
  isUpdating = true;

  try {
    // Update quantity limits first with fresh cart data
    await updateQuantityLimits();

    // Trigger variant picker change event
    const variantPicker = document.querySelector('hh-variant-picker');
    if (variantPicker) {
      variantPicker.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const inputQuantity = document.querySelector('.product__ctas [name=quantity]');
    const quantitySelector = document.querySelector('.product__ctas hh-quantity-input');

    // Update cart notification prices if needed
    await updateCartNotificationPrices(inputQuantity, window.itemQuantity);

    // Reset quantity values
    if (quantitySelector) {
      quantitySelector._value = 1;
    }
    if (inputQuantity) {
      inputQuantity.value = 1;
    }
    window.itemQuantity = 1;

  } catch (error) {
    console.error('Error in cart-updated handler:', error);
  } finally {
    // Reset flag after a brief delay
    setTimeout(() => {
      isUpdating = false;
    }, 200);
  }
});
